import classes from "./styles.module.css"
import {ReactComponent as IMAGE} from "./images/open_new_tab_img.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import {
    POLL_TYPE
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import {deCapitalizeWord} from "../../utils/helpers";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import React, {useEffect, useState} from "react";
import {ResponseApiCalls} from "../../apis/ResponseApiCalls";
import Skeleton from "react-loading-skeleton";

export default function OpenNewTab({pollCode=""}) {
    const { t } = useTranslation();
    const { getPollRecordFromUniqueCode,} = ResponseApiCalls();

    const [, getSession] = useLocalStorageNew("session", {});

    const [poll, setPoll] = useState({});
    const [dataReady, setDataReady] = useState(false)


    useEffect(() => {
        getPollRecordFromUniqueCode(pollCode).then(result => {
            setPoll(result.poll);
        }).finally(() => setDataReady(true));

    }, []);

    const onClickOpen = () => {
        const engageSession = encodeURIComponent(JSON.stringify(getSession()));
        const path = window.location.pathname;
        window.open(`/portal?engageSession=${engageSession}&dest=${path}&pollType=${poll.pollType}`);
    }

    if (!dataReady) {
        return (
            <div style={{width: "100%", height: "100%", padding: 15}}>
                <div className={classes.openNewTabCard}>
                    <div style={{flex: 1}}/>
                    <IMAGE/>
                    <div style={{height: 25, flexShrink: 1}}/>


                    <Skeleton width={400} height={25} inline={true} borderRadius={6} />

                    <div style={{height: 40, flexShrink: 1}}/>
                    <Skeleton width={200} height={25} inline={true} borderRadius={6} />
                    <div style={{flex: 1}}/>
                </div>
            </div>
        );
    }


    return (
        <div style={{width: "100%", height: "100%", padding: 15}}>
            <div className={classes.openNewTabCard}>
                <div style={{flex: 1}}/>
                <IMAGE/>
                <div style={{height: 25, flexShrink: 1}}/>


                <span>
                    {t("poll.openActivityInNewTabDescription", {
                        activityType: poll.pollType === POLL_TYPE.ATTENDANCE
                            ? deCapitalizeWord(t("poll.attendanceLabel"))
                            : deCapitalizeWord(t("poll.mergedModeText"))
                    })}
                </span>
                <div style={{height: 40, flexShrink: 1}}/>
                <YuJaButton style={{height: 35}} onClick={onClickOpen}>
                    {t("poll.openActivityInNewTab", {
                        activityType: poll.pollType === POLL_TYPE.ATTENDANCE
                            ? t("poll.attendanceLabel")
                            : t("poll.mergedModeText")
                    })}
                </YuJaButton>
                <div style={{flex: 1}}/>
            </div>
        </div>
    );
}